import React, { useEffect, useState } from "react";
import { Form, Button, Divider } from "antd";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { PhysicanItem as BasePhysicianItem } from "./PhysicianItem";
import { sizes } from "../../../../../constant/styles";
import { selectProvidersDoctors } from "../../../../../store/selector";
import { getFieldsToUpdateOnProviderChange } from "../../utils/provider";
import { OTHER, STATE } from "../../constants";
import { buildFieldValueMap } from "../../../../../utils/form";
import useConditionalValidation from "./utils/useConditionalValidation";
import { getStateCode } from "../../../../../constant/states";

export const GenericPhysicianItem = ({
  allowOther,
  form,
  formToPhysicianFieldMap,
  shouldValidateFields = false,
  ...props
}) => {
  const { t } = useTranslation();
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const selectedPhysician = Form.useWatch(props.name, form);
  const physicians = useSelector(selectProvidersDoctors);
  const formSectionName = props.name[0];

  useConditionalValidation(props.name, shouldValidateFields);

  useEffect(() => {
    if (selectedPhysician) {
      form.validateFields();
    }
  }, [selectedPhysician]);

  const updateFormOnPhysicianChange = async (value, option) => {
    const physicianId = Number(option?.key) || null;

    const fieldsToUpdate = getFieldsToUpdateOnProviderChange(physicians, physicianId, formToPhysicianFieldMap);
    if (fieldsToUpdate[STATE]) {
      fieldsToUpdate[STATE] = getStateCode(fieldsToUpdate[STATE]);
    }

    form.setFieldsValue({ [formSectionName]: { ...fieldsToUpdate } });
  };

  const handleOtherSelection = () => {
    form.setFieldsValue(buildFieldValueMap([[props.name, OTHER]]));
    setDropdownOpen(false);
    updateFormOnPhysicianChange(null);
  };

  if (!allowOther || !form) {
    return <BasePhysicianItem {...props} />;
  }

  return (
    <BasePhysicianItem
      {...props}
      shouldValidateFields={shouldValidateFields}
      isOpen={isDropdownOpen}
      onChange={updateFormOnPhysicianChange}
      onDropdownVisibleChange={setDropdownOpen}
      dropdownRender={(menu) => (
        <>
          {menu}
          <Divider style={{ margin: "8px 0" }} />
          <Button
            type="text"
            style={{ width: "100%", textAlign: "start", fontSize: sizes.medium, background: "transparent" }}
            onClick={handleOtherSelection}
          >
            {t("other")}
          </Button>
        </>
      )}
    />
  );
};
